// extracted by mini-css-extract-plugin
export default {"footer":"index-module_footer_tJOF2","links":"index-module_links_lJnAH","divider":"index-module_divider_e0mHN","span":"index-module_span_Fe31q"};